import React from 'react';
import PropTypes from 'prop-types';

/**
Il componente è stato pensato per visualizzare immagini.
 */
const Image = ({
  alt, title, src, ...others
}) => (
  <img
    alt={alt}
    src={src}
    title={title}
    {...others}
  />
);

Image.propTypes = {
  /** Indica il testo alternativo in caso di mancato caricamento dell'immagine */
  alt: PropTypes.string.isRequired,
  /** Indica il percorso sorgente da cui renderizzare l'immagine */
  src: PropTypes.string.isRequired,
  /** Indica il titolo dell'immagine */
  title: PropTypes.string.isRequired,
};

export default Image;
